/*

--------------------------------------------------------------------------------
Oriflame version of Kendo validator - doesn't extend original script in this case
--------------------------------------------------------------------------------

*/

; (function ($) {

    "use strict";

    var kendo = window.kendo;
    if (!kendo) return;
    if (kendo.ui.Validator && kendo.ui.Validator.updated) return;

    var proxy = $.proxy,
        Widget = kendo.ui.Widget,
        kv = kendo.ui.validator,
        NS = ".kendoValidator",
        POINT = ".",
        INVALIDMSG = "k-invalid-msg",
        invalidMsgRegExp = new RegExp(INVALIDMSG, "i"),
        HIDDEN = "hidden",
        NAME = "name",
        FORM = "form",
        EDITABLE = "[data-role=editable]",
        SERVER_INVALID_INPUT = "input-validation-error",
        GRID_VALID_SPAN = "span.field-validation-valid",
        DATA_INVALID_MESSAGE = "invalid-message",
        ERROR = "error",
        SUMMARY = ".k-summary",
        INVALID_WIDGETS = ".k-widget." + ERROR,
        ATTR_NOVALIDATE = "novalidate",
        ATTR_TITLE = "title",
        // validation UI types
        VAL_UI_ICON = "icon",
        // icon classes on widgets
        FOCUS = "focus",
        WAS_FOCUSED = "wasFocused",
        BLUR = "blur",
        CLICK = "click",
        PENDING = "pending",
        // check whether to call rules update at all
        haveMvcRules = (kv && kv.rules && typeof kv.rules.mvcmin != "undefined"),
        T_BOOLEAN = "boolean",
        T_NUMBER = "number",
        T_DATETIME = "datetime",
        T_STRING = "string",
        BOOLEAN_INPUT = ":checkbox",
        NUMBER_INPUT = "input[type=number], input[type=range]",
        DATETIME_INPUT = "input[type=date], input[type=time], input[type=datetime], input[type=datetime-local]",
        DATA_VALUE_TYPE = "data-val-type",
        DROPDOWN_DATEPICKER = ".k-dropdown-datepicker",
        ENABLED_INPUT_SELECTOR =
            ":input:not(:button,[type=submit],[type=reset],[disabled],[readonly]," +
            ".k-radiobuttonlist :radio,.k-dropdown-datepicker .k-combobox :input)",
        // appended to on-blur validation
        ADDITIONAL_COMPONENTS_SELECTOR = ".k-slider,.k-radiobuttonlist,.k-multiselect," + DROPDOWN_DATEPICKER,
        BLUR_VALIDATION_SELECTOR = ENABLED_INPUT_SELECTOR + "," + ADDITIONAL_COMPONENTS_SELECTOR,
        CONDITIONAL_REQUIRED_SELECTOR = "input[data-val-required-when]",
        REQUIRED_LABEL_CLASS = "required",
        ENABLED_CHECKBOX_SELECTOR = ":checkbox:not([disabled],[readonly])",
        CHECKBOX_SELECTOR = ":checkbox",
        ENABLED_RADIO_LIST_ITEM_SELECTOR = ".k-radiobuttonlist :radio:checked:not([disabled],[readonly])",
        RADIO_SELECTOR = ":radio",
        HELPER_INPUT_SELECTOR = ".k-formatted-value",
        REMOTE_DATA = "remoteState",
        REMOTE_VALIDATION = "data-val-remote",
        LOADING_ICON = ".k-icon.k-loading.remote-val",
        LOADING_ICON_TEMPLATE = '<span class="k-icon k-loading remote-val"></span>',
        EVENT_VALIDATE = "validate",
        EVENT_VALIDATE_RELATED = "validateRelatedInputs",
        EVENT_CHANGE = "change",
        EVENT_INPUT_VALIDATE = "inputValidate",
        EVENT_INPUT_REMOTE_VALIDATE = "inputRemoteValidate",
        EVENT_INVALID_INPUT_FOCUS = "invalidInputFocus",
        // some nice regex for validating e-mails, hopefully correctly converted
        // from c# FluentValidation's EmailValidator.Expression
        EMAIL_REGEX =
            "^((([a-z]|\\d|[!#\\$%&'\\*\\+\\-\\/=\\?\\^_`{\\|}~]|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])+" +
            "(\\.([a-z]|\\d|[!#\\$%&'\\*\\+\\-\\/=\\?\\^_`{\\|}~]|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])+)*)" +
            "|((\\x22)((((\\x20|\\x09)*(\\x0d\\x0a))?(\\x20|\\x09)+)?(([\\x01-\\x08\\x0b\\x0c\\x0e-\\x1f\\x7f]" +
            "|\\x21|[\\x23-\\x5b]|[\\x5d-\\x7e]|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])" +
            "|(\\\\([\\x01-\\x09\\x0b\\x0c\\x0d-\\x7f]|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF]))))" +
            "*(((\\x20|\\x09)*(\\x0d\\x0a))?(\\x20|\\x09)+)?(\\x22)))@((([a-z]|\\d|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])" +
            "|(([a-z]|\\d|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])([a-z]|\\d|-||_|~|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])*" +
            "([a-z]|\\d|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])))\\.)+(([a-z]|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])+" +
            "|(([a-z]|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])+([a-z]+|\\d|-|\\.{0,1}|_|~|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])?" +
            "([a-z]|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])))$",
        // another nice regex taken from kendo.aspnetmvc.js for not-so-far-rewritten validation rules logic
        NAME_SPECIAL_CHAR_REGEX = /("|\%|'|\[|\]|\$|\.|\,|\:|\;|\+|\*|\&|\!|\#|\(|\)|<|>|\=|\?|\@|\^|\{|\}|\~|\/|\||`)/g,
        DEFAULT_SCROLL_DURATION = 700,
        DEFAULT_SCROLLER = "document",
        TAB_INDEX = "tabindex",
        CONTROL_WRAPPER = ".w-control",
        DOCUMENT_NODE = 9;

    if (!kendo.ui.validator) kendo.ui.validator = { rules: {}, messages: {} };

    function resolveRules(element) {
        var resolvers = kendo.ui.validator.ruleResolvers || {},
            rules = {};
        for (var name in resolvers)
            if (resolvers.hasOwnProperty(name))
                $.extend(true, rules, resolvers[name].resolve(element));
        return rules;
    }

    function searchForMessageContainer($elements, fieldName) {
        var containers = $();
        for (var i = 0, length = $elements.length; i < length; i++) {
            var element = $elements[i];
            if (!invalidMsgRegExp.test(element.className)) continue;
            var attr = element.getAttribute(kendo.attr("for"));
            if (attr === fieldName) containers = containers.add(element);
        }
        return containers;
    }

    /**
     * Helper for parsing parameter or input values according to validated Kendo input type.
     * The format of .NET data attributes for validation differs from Kendo formatted values.
     * So we have to parse the params differently than input values.
     * 
     * isParam - When true, the value will be evaluated as .NET data attribute, otherwise
     * as Kendo formatted value.
     * 
     * input - Reference to validated input. We try to assert the value type from the Kendo
     * widget instance created on the input, otherwise we would end up only with strings
     * in most cases.
     * 
     * value - The parsed value. Usually a string.
     * 
     * defaultValue - Optional. Return value when the parsing was not successful
     * and / or returned undefined.
     *
     * TODO : solution for radios and other multi-option / array-value widgets
     */
    function parseValidationValue(isParam, $input, value, defaultValue) {
        var widget = kendo.widgetInstanceEx($input),
            widgetName = widget ? widget.options.name : "",
            valueType = T_STRING,
            format = widget ? widget.options.format : undefined,
            culture = widget ? widget.options.culture : "",
            valueTypeAttribute = $input.attr(DATA_VALUE_TYPE), // can manually redefine the value type in input control
            result;

        if (valueTypeAttribute)
            valueType = valueTypeAttribute;
        else if (widgetName)
            switch (widgetName) {
                case "CheckBox":
                    valueType = T_BOOLEAN;
                    break;
                case "NumericTextBox":
                    valueType = T_NUMBER;
                    break;
                case "DatePicker":
                case "TimePicker":
                case "DateTimePicker":
                case "DropDownDatePicker":
                    valueType = T_DATETIME;
                    // .NET datetime validation attributes seem to be written on server
                    // always with this format independent on culture, so we have
                    // to parse the same way
                    // TODO : fix this on server to get proper culture values rendered
                    if (isParam) format = "M/d/yyyy h:mm:ss";
                    break;
            }
        else if ($input.is(BOOLEAN_INPUT)) valueType = T_BOOLEAN;
        else if ($input.is(NUMBER_INPUT)) valueType = T_NUMBER;
        else if ($input.is(DATETIME_INPUT)) valueType = T_DATETIME;
        try {
            switch (valueType) {
                case T_BOOLEAN:
                    result = kendo.parseBoolean(value);
                    break;
                case T_NUMBER:
                    result = kendo.parseFloat(value, format, culture);
                    break;
                case T_DATETIME:
                    result = kendo.parseDate(value, format, culture);
                    break;
                default:
                    result = value;
            }
        } catch (error) {
            if (widget) widget.error("Error getting validation parameter value. %s", error);
        }
        if (typeof result == "undefined" && typeof defaultValue != "undefined") result = defaultValue;
        return result;
    }

    /**
     * Helper function to return wrapper element for given validator instance.
     * Usually it is a form. In grids edit modes it can be editable data role wrapper.
     */
    function validatorWrapper(validatorInstance) {
        return (validatorInstance && (validatorInstance.element.is(FORM) || validatorInstance.element.is(EDITABLE))) ?
            validatorInstance.element : $("body");
    }

    /**
     * Tries to find a related field and return it as a jQuery targetted object.
     * Prefferably starts the search in a form element bound to provided validator.
     */
    function findRelatedField(name, validatorInstance) {
        if (!name) return $();
        var $wrapper = validatorWrapper(validatorInstance);
        return $wrapper.find("[name='" + name + "']");
    }

    /**
     * Tries to find related fields for specified field name and return them as a jQuery targetted object.
     * Prefferably starts the search in a form element bound to provided validator.
     * Searches for validated inputs corresponding to a generic validation selector
     * and further filters the returned set based on data inspection of particular inputs.
     * All must meet conditions :
     * - data( "val" ) is equal to true
     * - data( "val<RuleName>Other" ) contains inputName
     */
    function findRelatedFieldsForInput(inputName, validatorInstance) {
        var OTHER = "Other";
        return validatorWrapper(validatorInstance)
            .find(BLUR_VALIDATION_SELECTOR)
            .filter(function () {
                var data = $(this).data();
                if (!data["val"]) return false;
                for (var key in data) {
                    if (!data.hasOwnProperty(key)) continue;
                    var k = $.trim(key);
                    if (!k) continue;
                    if (k.substr(0, 3) !== "val") continue;
                    if (k.substr(- OTHER.length) !== OTHER) continue;
                    if (data[key].indexOf(inputName) > -1) return true;
                }
                return false;
            });
    }

    /**
     * Used to check whether a given client-side validation rule should really be checked.
     * Tries first to find client-side condition first, and when one exists, tries to evaluate it.
     * When it returns true, the rule should be executed. When the condition doesn't exist,
     * the rule will be executed every time & no condition evaluation happens.
     * @param {} $input Validated input ( jQuery object )
     * @param {} params Validation params parsed from HTML data attributes on that particular input.
     * @param {} validatorInstance Current validator instance.
     * @returns {} true when the rule should be executed.
     */
    function shouldValidate($input, params, validatorInstance, ruleName) {
        if (!params || typeof params.when == "undefined") {
            return true;
        }
        var result = true,
            description = validatorInstance.describeElement($input);
        validatorInstance.info(
            "Client-side condition for validation rule '%s'" +
            " for input '%s' is set to '%s'. Evaluating condition ...",
            ruleName, description, params.when
        );
        try {
            result = params.when;
            if (typeof result == "string") {
                result = new Function("return " + result)();
            }
            if (typeof result == "function") {
                result = result($input, params, validatorInstance);
            }
            result = Boolean(result);
        } catch (error) {
            // on error we set it back to true, meaning the condition logic couldn't be evaluated
            // successfully, so consider the wrong condition to not be set at all
            result = true;
            validatorInstance.warning(
                "Error evaluating client-side condition for validation rule '%s', input '%s' : %s.",
                ruleName, description, error
            );
        }
        return result;
    }

    function patternMatcher(value, pattern) {
        if (typeof pattern == "string") {
            pattern = new RegExp("^(?:" + pattern + ")$");
        }
        return pattern.test(value);
    }

    function extractParams($input, ruleName) {
        var params = {},
            data = $input.data(),
            length = ruleName.length;
        for (var key in data) {
            if (!data.hasOwnProperty(key)) continue;
            var rule = key.toLowerCase(),
                index = rule.indexOf(ruleName);
            if (index > -1) {
                rule = rule.substring(index + length, key.length);
                if (rule) params[rule] = data[key];
            }
        }
        return params;
    }

    // appended / modified set of MVC rules
    // overrides for existing rules - more types now considered than only numbers for comparisons
    var validationRules = {
        required: function ($input, params, validatorInstance) {
            if (!shouldValidate($input, params, validatorInstance, "mvcrequired")) return true;
            var value = $input.val(),
                $checkbox = $input.filter("[type=checkbox]"),
                name;
            if ($checkbox.length) {
                name = $checkbox[0].name.replace(NAME_SPECIAL_CHAR_REGEX, "\\$1");
                var hiddenSelector = "input:hidden[name='" + name + "']";
                var $hidden = $checkbox.next(hiddenSelector);
                if (!$hidden.length) {
                    $hidden = $checkbox.next("label.k-checkbox-label").next(hiddenSelector);
                }
                if ($hidden.length) {
                    value = $hidden.val();
                } else {
                    value = $input.attr("checked") === "checked";
                }
            }
            return !(value === "" || !value);
        },
        number: function ($input, params, validatorInstance) {
            if (!shouldValidate($input, params, validatorInstance, "mvcnumber")) return true;
            return $input.val() === "" || $input.val() == null || kendo.parseFloat($input.val()) !== null || $input.val().length === 0;
        },
        regex: function ($input, params, validatorInstance) {
            if (!shouldValidate($input, params, validatorInstance, "mvcregex")) return true;
            if ($input.val() !== "") {
                return patternMatcher($input.val(), params.pattern);
            }
            return true;
        },
        length: function ($input, params, validatorInstance) {
            if (!shouldValidate($input, params, validatorInstance, "mvclength")) return true;
            if ($input.val() !== "") {
                var len = $.trim($input.val()).length;
                return (!params.min || len >= (params.min || 0)) && (!params.max || len <= (params.max || 0));
            }
            return true;
        },
        // for dates we need format when set in widget's options to correctly parse the input value
        date: function ($input, params, validatorInstance) {
            if (!shouldValidate($input, params, validatorInstance, "mvcdate")) return true;
            var val = parseValidationValue(false, $input, kendo.getInputValue($input), null),
                widget = kendo.widgetInstanceEx($input),
                widgetName = widget ? widget.options.name : "";
            if (widgetName === "DropDownDatePicker" && ($input.val() === "") !== widget.isEmpty()) {
                return false;
            }
            return $input.val() === "" || val instanceof Date;
        },
        // same as original but has to be here to call new min & max rules properly
        range: function ($input, params, validatorInstance) {
            if (!shouldValidate($input, params, validatorInstance, "mvcrange")) return true;
            if ($input.val() !== "")
                return this.min($input, params) && this.max($input, params);
            return true;
        },
        // override MVC min rule so that it uses localized values
        min: function ($input, params, validatorInstance) {
            if (!shouldValidate($input, params, validatorInstance, "mvcmin")) return true;
            var min = parseValidationValue(true, $input, params.min, null),
                val = parseValidationValue(false, $input, kendo.getInputValue($input)),
                widget = kendo.widgetInstanceEx($input);
            if (min == null && widget)
                widget.info(
                    "Unknown minimum parameter value for element %s, min validation rule will pass anyway.",
                    widget.describeElement($input)
                );
            return min <= val || min == null;
        },
        // override MVC max rule so that it uses localized values
        max: function ($input, params, validatorInstance) {
            if (!shouldValidate($input, params, validatorInstance, "mvcmax")) return true;
            var max = parseValidationValue(true, $input, params.max, null),
                val = parseValidationValue(false, $input, kendo.getInputValue($input)),
                widget = kendo.widgetInstanceEx($input);
            if (max == null && widget)
                widget.info(
                    "Unknown maximum parameter value for element %s, max validation rule will pass anyway.",
                    widget.describeElement($input)
                );
            return val <= max || max == null;
        },
        // additional client-side validations not supported by default by .NET / FluentValidation
        equal: function ($input, params, validatorInstance) {
            if (!shouldValidate($input, params, validatorInstance, "mvcequal")) return true;
            var $related = findRelatedField(params.other, validatorInstance),
                compare = $related.length ?
                    parseValidationValue(false, $related, kendo.getInputValue($related), null) :
                    parseValidationValue(true, $input, params.to, null),
                val = parseValidationValue(false, $input, kendo.getInputValue($input)),
                widget = kendo.widgetInstanceEx($input);
            if (compare == null && widget)
                widget.info(
                    "Unknown compare parameter value for element %s, equal validation rule will pass anyway.",
                    widget.describeElement($input)
                );
            // 2 date objects with same value are never equal
            return (val instanceof Date && compare instanceof Date && val.getTime() === compare.getTime()) ||
                compare === val || compare == null;
        },
        notequal: function ($input, params, validatorInstance) {
            if (!shouldValidate($input, params, validatorInstance, "mvcnotequal")) return true;
            var $related = findRelatedField(params.other, validatorInstance),
                compare = $related.length ?
                    parseValidationValue(false, $related, kendo.getInputValue($related), null) :
                    parseValidationValue(true, $input, params.to, null),
                val = parseValidationValue(false, $input, kendo.getInputValue($input)),
                widget = kendo.widgetInstanceEx($input);
            if (compare == null && widget)
                widget.info(
                    "Unknown compare parameter value for element %s, notequal validation rule will pass anyway.",
                    widget.describeElement($input)
                );
            // 2 date objects with same value are never equal
            return (val instanceof Date && compare instanceof Date) ?
                val.getTime() !== compare.getTime() :
                (compare !== val || compare == null);
        },
        exclusiverange: function ($input, params, validatorInstance) {
            if (!shouldValidate($input, params, validatorInstance, "mvcexclusiverange")) return true;
            if ($input.val() !== "")
                return this.greaterthan($input, params) && this.lessthan($input, params);
            return true;
        },
        lessthan: function ($input, params, validatorInstance) {
            if (!shouldValidate($input, params, validatorInstance, "mvclessthan")) return true;
            var to = parseValidationValue(true, $input, params.to, null),
                val = parseValidationValue(false, $input, kendo.getInputValue($input)),
                widget = kendo.widgetInstanceEx($input);
            if (to == null && widget && val != null)
                widget.warning(
                    "Unknown to parameter value for element %s, lessthan validation rule will pass anyway.",
                    widget.describeElement($input)
                );
            return val < to || val == null || to == null;
        },
        greaterthan: function ($input, params, validatorInstance) {
            if (!shouldValidate($input, params, validatorInstance, "mvcgreaterthan")) return true;
            var from = parseValidationValue(true, $input, params.from, null),
                val = parseValidationValue(false, $input, kendo.getInputValue($input)),
                widget = kendo.widgetInstanceEx($input);
            if (from == null && widget && val != null)
                widget.warning(
                    "Unknown from parameter value for element %s, greaterthan validation rule will pass anyway.",
                    widget.describeElement($input)
                );
            return from < val || val == null || from == null;
        },
        email: function ($input, params, validatorInstance) {
            if (!shouldValidate($input, params, validatorInstance, "mvcemail")) return true;
            var val = $input.val();
            if (val === "") return true;
            var pattern = new RegExp(EMAIL_REGEX, 'i');
            return pattern.test(val.trim());
        },
        creditcard: function ($input, params, validatorInstance) {
            if (!shouldValidate($input, params, validatorInstance, "mvccreditcard")) return true;
            // code taken from FluentValidation's CreditCardValidator & slightly modified
            var val = $input.val();
            if (val === "") return true;
            val = val.replace(/-/g, "").replace(/ /g, "");
            var num1 = 0,
                flag = false;
            for (var x = val.length - 1; x > -1; x--) {
                var c = val[x];
                if (c < "0" || c > "9") return false;
                var num2 = (val.charCodeAt(x) - 48) * (flag ? 2 : 1);
                flag = !flag;
                while (num2 > 0) {
                    num1 += num2 % 10;
                    num2 = Math.floor(num2 / 10);
                }
            }
            return num1 % 10 === 0;
        },

        /**
          * Remote validations use async AJAX logic to get validation result
          * from server. Form submit can be optionally blocked until all AJAX
          * requests return values or expire.
          * Only trigger validation request when some of the related values
          * had changed or wasn't validated yet. Otherwise simply return last
          * validated value stored in the lastRemoteState data.
          */
        remote: function ($input, params, validatorInstance) {
            if (!shouldValidate($input, params, validatorInstance, "mvcremote")) return true;
            var widget = kendo.widgetInstanceEx($input);
            // check validator instance is set
            if (!validatorInstance) {
                if (widget)
                    widget.warning(
                        "Unknown validator instance for element %s, " +
                        "remote validation rule will pass anyway and not trigger any AJAX calls.",
                        widget.describeElement($input)
                    );
                return true;
            }
            // check remote validation URL is set
            var url = params.url || null;
            if (url == null) {
                if (widget)
                    widget.warning(
                        "Unknown URL parameter value for element %s, remote validation rule will pass anyway.",
                        widget.describeElement($input)
                    );
                return true;
            }

            function getRelatedFields(related, inputName) {
                var result = "";
                try {
                    result = (new Function("return " + related))();
                    if (typeof result == "function") {
                        result = result() || "";
                    } else if (typeof result != "string") {
                        result = "";
                    }
                } catch (error) {
                    result = related || "";
                }

                if (typeof result == "string") {
                    result = result ? result.split(",") : [];
                }

                if (result.indexOf(inputName) < 0) {
                    result.push(inputName);
                }

                return result;
            }

            // get latest remote state for the widget saved in the input's data
            var $wrapper = validatorWrapper(validatorInstance),
                inputName = $input.attr("name"),
                fieldNames = getRelatedFields(params.related, inputName),
                lastRemoteState = $input.data(REMOTE_DATA) || {},
                i = fieldNames.length, l;

            // trim related field names
            while (i--) {
                var fieldName = $.trim(fieldNames[i]);
                if (!fieldName) fieldNames.pop(); else fieldNames[i] = fieldName;
            }

            function saveLastState() {
                $input.data(REMOTE_DATA, lastRemoteState);
            }

            function isChangedState() {
                for (var i = 0, l = fieldNames.length; i < l; i++) {
                    var $field = $wrapper.find("[name='" + fieldNames[i] + "']");
                    if (!$field.length) continue;
                    var val = kendo.getInputValue($field);
                    if (lastRemoteState[fieldNames[i]] !== val) return true;
                }
                return lastRemoteState.valid === undefined;
            }

            function getLastValues() {
                for (var i = 0, l = fieldNames.length; i < l; i++) {
                    var $field = $wrapper.find("[name='" + fieldNames[i] + "']");
                    if (!$field.length) continue;
                    var val = kendo.getInputValue($field);
                    lastRemoteState[fieldNames[i]] = val;
                }
            }

            // When user didn't edit it from last time evaluation
            // check when it was evaluated at all yet.
            // When yes, return last evaluation result.
            if (!isChangedState()) return lastRemoteState.valid;
            // will return special pending value to optionally change loading UI
            // and optionally block form submit
            lastRemoteState.valid = PENDING;
            // start AJAX request only when not currently submitting the form
            if (validatorInstance._tryingToSubmit) return lastRemoteState.valid;
            // TODO : make some dedicated method for this in validator
            validatorInstance._pendingCount++;
            getLastValues();
            lastRemoteState.ajaxId = ++validatorInstance._lastRemoteCallId;
            // AJAX in progress - indication for UI
            lastRemoteState.active = true;
            // save data for the input for later
            saveLastState();
            // prepare AJAX request
            var ajaxData = {
                ajaxId: lastRemoteState.ajaxId,
                related: {},
                activeInput: inputName.replace("[", "{").replace("]", "}")
            };
            ajaxData[inputName] = lastRemoteState[inputName];
            // append name - value pairs with validated form data properties
            for (i = 0, l = fieldNames.length; i < l; i++) {
                var $field = $wrapper.find("[name='" + fieldNames[i] + "']");
                if (!$field.length) continue;
                ajaxData.related[fieldNames[i].replace("[", "{").replace("]", "}")] = lastRemoteState[fieldNames[i]];
            }
            $.ajax({
                /* contentType : "application/json", */
                dataType: "json",
                method: "post",
                url: url,
                data: ajaxData
            })
                .done(function (response) {
                    validatorInstance.info("remote AJAX success, response : %o", response);
                    if (!response || typeof response != "object") {
                        // some error probably occured, so we can probably only skip
                        // as if the field was valid ( other attempt probably returns the same )
                        lastRemoteState.valid = true;
                        lastRemoteState.active = false;
                        saveLastState();
                        // change UI
                        validatorInstance.validateInput($input);
                        var eventData = {
                            inputName: inputName,
                            valid: true,
                            data: ajaxData,
                            response: null
                        };
                        validatorInstance.trigger(EVENT_INPUT_REMOTE_VALIDATE, eventData);
                        $input[0].dispatchEvent(new CustomEvent(EVENT_INPUT_REMOTE_VALIDATE, { detail: eventData, bubbles: true }));
                        return;
                        // could also do something like
                        // result = kendo.parseBoolean( response );
                        // but still we don't know the request ID
                    }
                    // check AJAX request ID
                    if (response.ajaxId < lastRemoteState.ajaxId) {
                        // ignore completely
                        validatorInstance.info(
                            "AJAX request %s will be ignored. Request ID should be %s.",
                            response.ajaxId, lastRemoteState.ajaxId
                        );
                        return;
                    }
                    validatorInstance.info("remote validation result : %s", response.result);
                    // reset field valid state according to returned result
                    lastRemoteState.valid = response.result;
                    lastRemoteState.active = false;
                    saveLastState();
                    // save response.message
                    if (!response.result) {
                        if (response.message) {
                            $input.attr(REMOTE_VALIDATION, response.message);
                        } 
                        if (response.messages && response.messages.length) {
                            var messages = "<ul><li>" + response.messages.join("</li><li>") + "</li></ul>";
                            $input.attr(REMOTE_VALIDATION, messages);
                        }
                    }
                        
                    // change UI
                    validatorInstance.validateInput($input);
                    // TODO : validate also related inputs ?
                    var eventData = {
                        inputName: inputName,
                        valid: response.result,
                        data: ajaxData,
                        response: response
                    };
                    validatorInstance.trigger(EVENT_INPUT_REMOTE_VALIDATE, eventData);
                    $input[0].dispatchEvent(new CustomEvent(EVENT_INPUT_REMOTE_VALIDATE, { detail: eventData, bubbles: true }));
                })
                .fail(function (xhr, statusText, errorText) {
                    validatorInstance.error(
                        "remote AJAX failed, xhr : %o, statusText : %s, errorText : %s",
                        xhr, statusText, errorText
                    );
                    lastRemoteState.valid = true;
                    lastRemoteState.active = false;
                    saveLastState();
                    validatorInstance.validateInput($input);
                    var eventData = {
                        inputName: inputName,
                        valid: true,
                        data: ajaxData,
                        response: null
                    };
                    validatorInstance.trigger(EVENT_INPUT_REMOTE_VALIDATE, eventData);
                    $input[0].dispatchEvent(new CustomEvent(EVENT_INPUT_REMOTE_VALIDATE, { detail: eventData, bubbles: true }));
                })
                .always(function () {
                    // reset validator pending state
                    if (validatorInstance._pendingCount) validatorInstance._pendingCount--;
                });
            return lastRemoteState.valid;
        },
        // TODO : solve this another way later
        customJSValidation: function ($input, params, validatorInstance) {
            if (!shouldValidate($input, params, validatorInstance, "mvccustomJSValidation")) return true;
            return $input.attr("data-custom-js-validation-result") === "true";
        }
    },
        // returns object with updated rules
        overrideRules = function () {
            // want to override only MVC rules for now
            if (!haveMvcRules) return null;
            var createRule = function (ruleName) {
                return function ($input, validatorInstance) {
                    if ($input.filter("[data-val-" + ruleName + "]").length)
                        return validationRules[ruleName](
                            $input, extractParams($input, ruleName), validatorInstance
                        );
                    return true;
                };
            },
                generateRules = function () {
                    var rules = {};
                    for (var name in validationRules)
                        if (validationRules.hasOwnProperty(name))
                            rules["mvc" + name] = createRule(name);
                    return rules;
                };
            return generateRules();
        },
        // returns object with updated messages
        overrideMessages = function () {
            // want to override only MVC messages for now
            if (!haveMvcRules) return null;
            var createMessage = function (rule) {
                return function (input) {
                    return input.attr("data-val-" + rule);
                };
            },
                generateMessages = function () {
                    var messages = {};
                    for (var name in validationRules)
                        if (validationRules.hasOwnProperty(name))
                            messages["mvc" + name] = createMessage(name);
                    return messages;
                };
            return generateMessages();
        };

    /**
     * Sometimes we run blur validation on wrappers, so have to find
     * the actual input.
     */
    function findInput(input) {
        var $input = $(input);
        if ($input.is(DROPDOWN_DATEPICKER))
            $input = $input.find("> input");
        else if (!$input.is("input,textarea"))
            $input = $input.find("input,textarea");
        return $($input[0]);
    };

    /**
     * Removes or replaces server-side generated classes for invalid controls.
     * Could actually be changed in server MVC logic, but for now
     * it is changed here in JS.
     */
    function replaceServerGeneratedClasses() {
        var self = this,
            $inputs = self.element.is(FORM) ?
                self.element.find(POINT + SERVER_INVALID_INPUT) :
                self.element;
        self.info("replaceServerGeneratedClasses(), $inputs : %o", $inputs);
        if (self.options.showFieldErrorsInWidgets && $inputs.hasClass(SERVER_INVALID_INPUT))
            $inputs.addClass(ERROR);
        $inputs.removeClass(SERVER_INVALID_INPUT);
    }

    /**
     * Removes server-side generated spans for valid controls in grid editation.
     * Could actually be changed in server MVC logic, but for now
     * it is changed here in JS. When not removed, it would now break validation
     * logic with wrong markup.
     */
    function cleanupGridValidationMarkup() {
        var self = this,
            $inputs = self.element.is(EDITABLE) ?
                self.element.find(GRID_VALID_SPAN) :
                $();
        self.info("cleanupGridValidationMarkup(), $inputs : %o", $inputs);
        $inputs.remove();
    }

    /**
     * Creates validation error messages after the form has been
     * reloaded and some fields are invalid.
     */
    function createErrorMessages() {
        var self = this;
        if (!self.options.showFieldErrorsInWidgets) return;
        if (self.element.is(FORM)) {
            var $inputs = self.element.find("[data-" + DATA_INVALID_MESSAGE + "]");
            $inputs.each(function () {
                self._createErrorMessage($(this));
            });
        } else
            self._createErrorMessage(self.element);
    }

    /**
      * Gets a validation message from the element's data
      * invalid-message attribute and creates a validation message
      * markup visible for the user near the validated input.
      */
    function createErrorMessage(element) {
        var self = this,
            $element = $(element),
            msg = $element.data(DATA_INVALID_MESSAGE);
        if (!msg) {
            return;
        }
        self.errorMessage($element, msg, self.options);
    }

    /**
     * Replaces remaining validation message placeholders after validating
     * widget value. There is following list of placeholders to be replaced
     * as of now :
     *
     * {Value} - Current input value.
     * {TotalLength} - The length of string input value.
     */
    function prepareErrorMessageText(input, message) {
        var value = kendo.getInputValue(input),
            data = {
                "Value": value,
                "TotalLength": (typeof value == "string" ? value.length : 0)
            };
        return message ? message.formatWith(data) : "";
    }

    /**
     * Toggles loading icon for pending validation state.
     */
    function toggleLoadingIcon(input, visible) {
        var $wrapper = kendo.findWrapper(input),
            hasWrapper = ($wrapper && $wrapper.length),
            $loading = (hasWrapper ? $wrapper : input).find(LOADING_ICON).toggle(visible);
        if (visible && !$loading.length)
            (hasWrapper ? $wrapper : input).append($(LOADING_ICON_TEMPLATE));
    }

    /**
     * Hides the specified element, optionally executing a callback function
     * after the animation end.
     */
    function hideElement(element, callback) {
        var $element = $(element),
            duration = this.options.duration || 400;
        if (!$element.length) return;
        $element
            .stop(true, false)
            .fadeOut({
                duration: duration,
                complete: function () {
                    $element
                        .addClass(HIDDEN)
                        .attr("style", null);
                    if (typeof callback == "function") callback();
                }
            });
    }

    /**
     * Always want to block validation of related fields when validate()
     * was called on the whole form.
     */
    function validate() {
        var self = this,
            result = true,
            state = self.value();
        self._errors = {};
        if (!self.element.is(BLUR_VALIDATION_SELECTOR)) {
            var $inputs = self.element.find(this._inputSelector);
            for (var i = 0, length = $inputs.length; i < length; i++)
                if (!self.validateInput($inputs.eq(i), true))
                    result = false;
        } else
            result = self.validateInput(self.element);
        self._allValidated = true;
        self.trigger(EVENT_VALIDATE, { valid: result });
        if (state !== result) self.trigger(EVENT_CHANGE);
        return result;
    }

    /**
     * To be able to connect the error label to a specific control,
     * we need its ID. So we have to override the validateInput() method.
     */
    function validateInput(input, avoidRelatedFieldsValidation) {
        var $input = $(input);
        if (!$input.length) {
            return true;
        }
        // don't want to validate helper inputs
        if ($input.is(HELPER_INPUT_SELECTOR)) {
            return true;
        }
        // don't want to validate input without validation currently switched on
        if ($input.data("val") !== true) {
            return true;
        }
        // want to validate only selected item when it is a radio in radio button list
        if ($input.is(RADIO_SELECTOR)) {
            $input = $input.filter(ENABLED_RADIO_LIST_ITEM_SELECTOR);
        }
        var self = this;
        // mark attempt to validate any input
        self._isValidated = true;
        self.info("Validating %s ...", self.describeElement($input));
        var result = self._checkValidity($input),
            valid = result.valid,
            fieldName = $input.attr(NAME) || "",
            messageText = "";
        // result can now return PENDING state
        if (!valid) {
            messageText = self._extractMessage($input, result.key);
            self._errors[fieldName] = messageText;
        }
        // toggle loading icon
        var lastRemoteState = $input.data(REMOTE_DATA) || {};
        self.toggleLoadingIcon($input, lastRemoteState.active);
        // update displayed error messages in widget & summary
        self._updateDisplayedInputErrors($input, valid, messageText);
        // trigger input validation event
        self.trigger(EVENT_INPUT_VALIDATE, { inputName: fieldName, valid: valid });
        // validate related fields' inputs - doesn't influence validation result of current field
        if (valid === true && !avoidRelatedFieldsValidation) {
            self.validateRelatedInputs(input);
        }
        return valid;
    }

    /**
     * @returns Closest validation summary as a jQuery object.
     */
    function getSummary() {
        var self = this,
            summaryId = self.options.summaryId;
        return summaryId ? $("#" + summaryId) : kendo.nearest(self.element, SUMMARY);
    }

    /**
     * @returns Closest validation summary's errors section as a jQuery object.
     */
    function getSummaryErrorsSection() {
        var self = this;
        return self.getSummary().find(
            POINT + self.options.errorSummaryCssClass.split(" ").join(POINT)
        );
    }

    /**
     * @returns Closest validation summary's success section as a jQuery object.
     */
    function getSummarySuccessSection() {
        var self = this;
        return self.getSummary().find(
            POINT + self.options.errorSummaryCssClass.split(" ").join(POINT)
        );
    }

    function updateDisplayedInputErrors($input, valid, messageText) {
        var self = this,
            instance = kendo.findWidgetInstance($input);
        // toggle error message
        if (!valid) {
            self.errorMessage($input, messageText, self.options);
        } else {
            self.hideErrorMessage($input, self.options);
        }
        // message in validation summary
        // If invalid & no input specified, this creates a generic error message in summary.
        if (self.options.showFieldErrorsInSummary || (!valid && (!$input || !$input.length))) {
            var $errors = self.getSummaryErrorsSection(),
                $success = self.getSummarySuccessSection();
            if ($errors.length) {
                if (!valid) {
                    $success.addClass(HIDDEN);
                    self.summaryMessage($errors, $input, messageText, self.options);
                } else {
                    self.hideSummaryMessage($errors, $input);
                }
            }
        }
        // try to update the widget size when needed
        // TODO : better - resize event ?
        if (instance) {
            if (typeof instance._placeholder == "function") {
                instance._placeholder();
            }
            switch (instance.options.name) {
                case "Slider":
                case "RangeSlider":
                    instance.recalculateSize();
                    break;
            }
        }
    }

    /**
     * Better checking whether rules are empty or crippled in some other way.
     * When some rule is invalid, evaulating other rules is stopped and valid
     * property of the returned result is set to false and key is set to first
     * failed rule name.
     * When some rule returns PENDING, evaluating other rules is not stopped,
     * returned valid property will be PENDING and key is set to the rule name
     * ( "remote" ), unless no other errors are found later.
     * When all rules are valid and none remote, the valid property is set to
     * true and no rule key is needed.
     */
    function checkValidity(input) {
        var self = this,
            rules = self.options.rules,
            result = { valid: true };
        for (var rule in rules) {
            if (!rules.hasOwnProperty(rule)) continue;
            if (typeof rules[rule] != "function") continue;
            var tmpResult = rules[rule](input, self);
            if (!tmpResult) {
                result = { valid: tmpResult, key: rule };
                self.warning(
                    "_checkValidity - input : %s, failed on rule : %s",
                    self.describeElement(input), rule
                );
                return result;
            } else if (tmpResult === PENDING) {
                result = { valid: tmpResult, key: rule };
                self.info(
                    "_checkValidity - input : %s, pending on remote rule ...",
                    self.describeElement(input)
                );
            }
        }
        return result;
    }

    /**
     * Validates related inputs for currently validated input when available.
     * The validation of related fields is based on data / attributes of these fields,
     * not on the currently validated control. Validated only when related field
     * was focused by the user, or the form was already validated.
     */
    function validateRelatedInputs(input) {
        var self = this,
            $input = $(input),
            name = $input.attr(NAME),
            result = {
                valid: true,
                inputName: name,
                invalidInputs: []
            };
        if ($input.length) {
            var isValid = self.value(),
                $inputs = findRelatedFieldsForInput(name, self)
                    .filter(function () {
                        // suppose "dirty" field
                        return $(this).data(WAS_FOCUSED) || self._allValidated;
                    });
            for (var i = 0, length = $inputs.length; i < length; i++) {
                if (!self.validateInput($inputs.eq(i), true)) {
                    result.valid = false;
                    result.invalidInputs.push($inputs.eq(i));
                }
            }
            self.trigger(EVENT_VALIDATE_RELATED, result);
            if (!result.valid && isValid !== result.valid)
                self.trigger(EVENT_CHANGE);
        }
        return result;
    }

    /**
     * Displays validation result from the JSON result object. So far it just shows errors
     * via errorMessage() and optionally summaryMessage(), no hiding errors and / or scrolling
     * to first highlighted errror yet. If there are no errors in the result object, this method does
     * nothing.
     * @param result JSON object optionally containing list of error messages for particular fields.
     * @param clearOldGenericErrors when true, the routine removes all generic errors not bound to particular
     * form fields from the summary first before rendering the new ones. Default is true.
     */
    function displayValidationResult(result, clearOldGenericErrors) {
        // There shouldn't be old validation errors highlighted in form, otherwise the form couldn't be commited.
        if (!result || !result.errors) {
            return;
        }
        if (typeof clearOldGenericErrors == "undefined") {
            clearOldGenericErrors = true;
        }
        var self = this,
            isForm = !self.element.is(BLUR_VALIDATION_SELECTOR),
            $validated = isForm ? self.element.find(this._inputSelector) : self.element;
        if (clearOldGenericErrors) {
            self.hideSummaryMessage(self.getSummaryErrorsSection());
        }
        for (var fieldName in result.errors) {
            if (!result.errors.hasOwnProperty(fieldName)) {
                continue;
            }
            var messageText = result.errors[fieldName];
            if (!messageText) {
                continue;
            }
            var $input = $validated.filter("[name=" + fieldName + "]");
            self._updateDisplayedInputErrors($input, false, messageText);
        }
    }

    /**
     * In default implementation title attribute has precedence before custom
     * validation message set via MVC validation scripts. We want the custom
     * message to have precedence and title attribute should be last fallback.
     */
    function extractMessage($input, ruleKey) {
        var self = this,
            customMessage = self.options.messages[ruleKey],
            fieldName = $input.attr(NAME);
        customMessage = kendo.isFunction(customMessage) ?
            customMessage($input) : customMessage;
        return kendo.format(
            $input.attr(kendo.attr(ruleKey + "-msg")) ||
            $input.attr("validationMessage") ||
            customMessage ||
            $input.attr(ATTR_TITLE) || "",
            fieldName, $input.attr(ruleKey)
        );
    }

    /**
     * Additional logic for PENDING form state.
     * Pending mode - some AJAX requests for remote validation rule(s) didn't
     * return value yet. We might want to stop submitting the form in this case.
     */
    function isPendingMode() {
        var self = this;
        return self.options.blockSubmitInPendingMode && (self._pendingCount > 0);
    }

    /**
     * Focuses first invalid input and tries to scroll the view so that
     * it becomes visible for the user.
     */
    function focusFirstInvalidInput() {
        var self = this;
        self.info("Focusing first invalid input ...");
        // TODO : proper invalid widget selector ?
        var $element = self.element.is(FORM) ?
            self.element.find(".k-widget.error") :
            self.element;
        if (!$element.length) return;
        $element = $($element[0]);
        self.info("Found element : %s", self.describeElement($element));
        var $wrapper = $element.closest(CONTROL_WRAPPER);
        if ($wrapper.length)
            self.info("Found element's wrapper, scrolling will be related to it.");
        else
            $wrapper = $element;

        // detect whether element and optionally it's labels in a wrapper
        // are currently visible in viewport
        // when in iframe, so far we solve only the state when whole iframe is visible
        // ( so not the situation with scrollbars in both parent & iframe; when this happens,
        // for now the scrolling should be switched off and only focusing first invalid
        // element could be enabled )
        // iframe detection : need ID, when not specified, for same domain can compare iframe objects directly,
        // for cross-domain have only the option of comparing URLs if possible
        // ( do not know the ID automatically in iframe when not set )
        // TODO : even if comparing URLs of iframes on different domains would be possible,
        // the iframe could inside be reloaded to different page, so src is probably still set ?
        // but the content of page URL is now different - investigate more
        var isIframe = kendo.isIframe,
            // isCrossDomain = kendo.isCrossDomainIframe,
            elementRect = kendo.boundingRect($wrapper),
            isFullyVisible = /* isIframe ? true : */ kendo.isElementInViewport($wrapper),
            doScrolling = self.options.scrollToFirstInvalidInput,
            duration = self.options.scrollDuration,
            scroller = self.options.scroller || DEFAULT_SCROLLER,
            scrollSettings = {
                x: { delta: self.options.scrollDeltaLeft || 0 },
                y: { delta: self.options.scrollDeltaTop || 0 }
            };
        if (isNaN(duration)) duration = DEFAULT_SCROLL_DURATION;

        /**
         * Focusing the element scrolls the page in some browsers, too,
         * but with bugs & only exactly to the activated input.
         * So we call it as last step after scroll animation if one happens,
         * otherwise immediatelly.
         */
        function focusIt() {
            // try to find widget instance and use its focus() method
            var instance = kendo.findWidgetInstance($element) || $element[0],
                isWrapper = $wrapper.is(CONTROL_WRAPPER),
                createTabIndex = isWrapper && !$wrapper.attr(TAB_INDEX);
            if (createTabIndex) {
                // enables focusing element programmatically
                $wrapper.attr(TAB_INDEX, "-1");
                $wrapper.focus();
                setTimeout(function () { $wrapper.removeAttr(TAB_INDEX); });
            }
            if (!instance || typeof instance.focus != "function") return;
            // focus it
            instance.focus();
            // select whole value
            setTimeout(function () {
                var $input = $element.find(".k-input:visible");
                try {
                    if ($input.length) $input.select();
                } catch (error) { }
                self.trigger(EVENT_INVALID_INPUT_FOCUS, { input: $input });
            });
        }

        /**
         * Tries to scroll to-be-focused element into view.
         * Scroll
         */
        function scrollIt() {
            self.info("Trying to scroll element into viewport ...");
            // either same page or parent page on same domain; get reference of whole document
            // TODO : not working so far for parent page on same domain, maybe skip it at all
            // and solve all iframes via postMessage ?
            var $doc = /* isIframe ? $( parent.document ) : */ $(document),
                getScroller = function (s) {
                    if (s === "window") return $doc[0].defaultView;
                    if (s === "document") return $doc[0];
                    return (typeof s == "string" ? $doc.find(s) : s);
                },
                defaultScrollProps = kendo.scrollProps(getScroller(DEFAULT_SCROLLER)),
                selectedScrollProps = kendo.scrollProps(getScroller(scroller)),
                selectScroller = function (axis) {
                    if ((!defaultScrollProps || !defaultScrollProps[axis].canScroll) &&
                        (!selectedScrollProps || !selectedScrollProps[axis].canScroll)) return null;
                    if (selectedScrollProps[axis].canScroll) {
                        scrollSettings[axis].scroller = selectedScrollProps;
                        return selectedScrollProps;
                    }
                    scrollSettings[axis].scroller = defaultScrollProps;
                    return defaultScrollProps;
                },
                checkScroll = function (axis) {
                    var suffix1 = (axis === "x") ? "Width" : "Height",
                        suffix2 = (axis === "x") ? "Left" : "Top",
                        max = window["inner" + suffix1] || document.documentElement["client" + suffix1];
                    if (elementRect[axis].min >= 0 && elementRect[axis].max <= max) return;
                    var scroller = selectScroller(axis);
                    if (!scroller)
                        self.warning("Couldn't find proper scrolling element for axis %s.", axis);
                    else {
                        scrollSettings[axis].newScroll = {};
                        scrollSettings[axis].newScroll["scroll" + suffix2] = /* isIframe ?
                            0 : // TODO : finalize for same domain iframe */
                            scroller[axis].scroll + elementRect[axis].min - scrollSettings[axis].delta;
                        self.info("Scroll settings for axis %s : %o", axis, scrollSettings[axis]);
                    }
                };
            var axes = ["x", "y"];
            axes.forEach(checkScroll);
            // do only one animation when scroller is same for both axes
            if (scrollSettings["x"].scroller && scrollSettings["x"].scroller === scrollSettings["y"].scroller) {
                $.extend(scrollSettings["x"].newScroll, scrollSettings["y"].newScroll);
                axes.pop();
            }
            axes.forEach(function (axis) {
                if (!scrollSettings[axis].scroller || !scrollSettings[axis].newScroll) return;
                var animated = scrollSettings[axis].scroller.element;
                // TODO : better with following ?
                if (animated.nodeType === DOCUMENT_NODE) animated = "html,body";
                $(animated)
                    .stop()
                    .animate(scrollSettings[axis].newScroll, duration);
            });
        }

        self.info("Element is %sfully visible in viewport.", isFullyVisible ? "" : "not ");
        self.info("Element is %sin iframe.", isIframe ? "" : "not ");
        self.info("Element client bounding rectangle : %o", elementRect);

        // Focusing the invalid field anyway after a given timeout for scroll animation.
        // Animation can be done different ways ( in current page ( iframe or not )
        // or parent page ( crossdomain communication or not ) ).
        var d = (!doScrolling || (isFullyVisible && !isIframe)) ? 0 : duration;
        self.info("Found element to be focused after %s ms.", d);
        setTimeout(focusIt, d);

        if (!doScrolling) return;

        // scroll view to show element in current page
        if (!isFullyVisible && !isIframe) {
            // can animate here
            if (elementRect) scrollIt();
            return;
        }

        // when iframe, we just inform the parent page, do not animate here so far
        if (!isIframe) return;
        // can be animated in parent page
        // TODO : trigger event with duration & probably element to be focused ?
        // send message
        var elementOffset = $wrapper.offset(),
            iframeId = window.frameElement ? window.frameElement.id : "";
        if (!iframeId) iframeId = self.options.iframeId || "";
        var msg = "?action=scrollToIframeElement" +
            "&frameid=" + iframeId +
            // "&url=" + encodeURIComponent(window.location.href) + // TODO : iframe ID ? is URL useful at all ?
            "&duration=" + d +
            "&x=" + elementOffset.left +
            "&y=" + elementOffset.top +
            "&sx=" + $wrapper.outerWidth() +
            "&sy=" + $wrapper.outerHeight() +
            "&dx=" + scrollSettings["x"].delta +
            "&dy=" + scrollSettings["y"].delta;
        self.info("Sending message to parent : '%s' ...", msg);
        parent.postMessage(msg, "*");
    }

    /**
     * Form submit handler blocked on invalid data and optionally when in
     * PENDING mode - blockSubmitInPendingMode must be set to true to block.
     */
    function submit(event) {

        var self = this;

        function blockSubmit() {
            event.stopPropagation();
            event.stopImmediatePropagation();
            event.preventDefault();
            self._tryingToSubmit = false;
            if (self.options.focusFirstInvalidInput)
                focusFirstInvalidInput.call(self);
            return false;
        }

        self._tryingToSubmit = true;
        if (!self.validate()) return blockSubmit();
        if (self.isPendingMode()) return blockSubmit();
        self._tryingToSubmit = false;
        return true;
    }

    /**
     * Have to redeclare the _attachEvents() mehod again just to have another
     * selection of applied objects ( added sliders ).
     */
    function attachEvents() {
        var self = this,
            $form;
        if (self.element.is(FORM)) {
            self.element.on("submit" + NS, proxy(self._submit, self));
            $form = self.element;
        } else {
            $form = self.element.closest(FORM);
        }
        if ($form.length) {
            self._resetHandler = function () {
                setTimeout(function () {
                    self.reset();
                });
            };
            self._form = $form.on("reset" + NS, self._resetHandler);
        }
        if (!self.options.validateOnBlur) return;
        if (self.element.is(BLUR_VALIDATION_SELECTOR)) {
            var $input = findInput(self.element);
            self.element
                .on(FOCUS + NS, function () {
                    $input.data(WAS_FOCUSED, true);
                })
                .on(BLUR + NS, function (event) {
                    self.info("blur event : %o", event);
                    if (!$input.is(".k-radiobuttonlist :radio"))
                        self._checkElement($input);
                })
                .on(CLICK + NS, CHECKBOX_SELECTOR, function () {
                    if ($input.is(ENABLED_CHECKBOX_SELECTOR))
                        self._checkElement($input);
                });
        } else {
            var validateCheckBox = function () {
                // check again if checkbox is enabled
                var $input = findInput(this);
                if ($input.is(ENABLED_CHECKBOX_SELECTOR)) self._checkElement($input);
            };
            self.element
                .on(FOCUS + NS, BLUR_VALIDATION_SELECTOR, function () {
                    var $this = $(this),
                        $input = findInput($this);
                    $input.data(WAS_FOCUSED, true);
                })
                .on(BLUR + NS, BLUR_VALIDATION_SELECTOR, function (event) {
                    var $this = $(this),
                        $input = findInput($this);
                    self.info("delegated blur event : %o, $this : %o, $input : %o", event, $this, $input);
                    if ($this.is(".k-multiselect select"))
                        self._checkElement($this);
                    else if ($input.is(".k-radiobuttonlist :radio")) {
                        if (!$(event.target).is(":radio")) return;
                        $input = $input.closest(".k-radiobuttonlist ul");
                        setTimeout(function () {
                            // $input = $input.closest( ".k-radiobuttonlist" ).find( ":radio:checked:not([disabled],[readonly])" );
                            // self.info( "found input : %s", self.describeElement( $input ) );
                            // for now we validate the radiobuttonlist wrapper
                            // from its aria-valuenow attribute
                            // self._checkElement( $input );
                            self.info(
                                "self : %s, $input : %s, current value : %s",
                                self, $input,
                                $input.attr("aria-valuenow")
                            );
                            // only validate when the radiobuttonlist lost focus
                            if (kendo.isChildOf($(document.activeElement), $input.parent())) return;
                            self._checkElement($input);
                        }, 0);
                    } else
                        self._checkElement($input);
                });
            if (self.element.is(CHECKBOX_SELECTOR)) {
                self.element.on(CLICK + NS, validateCheckBox); // TODO : should be change rather than click
            } else if (self.element.is(FORM)) {
                self.element.find(CHECKBOX_SELECTOR)
                    .on(CLICK + NS, validateCheckBox);
            }
        }
    }

    function destroy() {
        Widget.fn.destroy.call(this);
        this.element.off(NS);
    }

    function value() {
        return this._isValidated ? this.errors().length === 0 : false;
    }

    function checkElement(element) {
        var state = this.value();
        this.validateInput(element);
        if (this.value() !== state) this.trigger(EVENT_CHANGE);
    }

    /**
     * Hides generated error messages UI in form widgets and/or validation summary if any.
     */
    function hideMessages() {
        var self = this,
            $errors = self.getSummaryErrorsSection(),
            $elements = self.element.is(FORM) ?
                self.element.find(INVALID_WIDGETS) :
                self.element;
        if ($errors.length) {
            // Hides generic errors not bound with particular fields first.
            self.hideSummaryMessage($errors);
        }
        if (!$elements.length) {
            return;
        }
        $elements.each(function () {
            var $element = $(this),
                $inputs = $element.find(BLUR_VALIDATION_SELECTOR);
            if (!$inputs.length) {
                return true;
            }
            $inputs.each(function () {
                var $input = $(this);
                // don't want to touch helper inputs
                if ($input.is(HELPER_INPUT_SELECTOR)) {
                    return true;
                }
                // want to touch only selected item when it is a radio in radio button list TODO: correct?
                if ($input.is(RADIO_SELECTOR)) {
                    $input = $input.filter(ENABLED_RADIO_LIST_ITEM_SELECTOR);
                }
                self.hideErrorMessage($input, self.options);
                // message in validation summary when found
                if (self.options.showFieldErrorsInSummary && $errors.length) {
                    self.hideSummaryMessage($errors, $input);
                }
                // try to update the widget size when needed
                // TODO : better - resize event ?
                var instance = kendo.findWidgetInstance($input);
                if (instance) {
                    if (typeof instance._placeholder == "function") {
                        instance._placeholder();
                    }
                    switch (instance.options.name) {
                        case "Slider":
                        case "RangeSlider":
                            instance.recalculateSize();
                            break;
                    }
                }
            });
        });
    }

    function findMessageContainer(fieldName) {
        var locators = kendo.ui.validator.messageLocators,
            $containers = $();
        for (var i = 0, length = this.element.length; i < length; i++)
            $containers = $containers.add(
                searchForMessageContainer(this.element[i].getElementsByTagName("*"), fieldName)
            );
        for (var name in locators)
            if (locators.hasOwnProperty(name))
                $containers = $containers.add(locators[name].locate(this.element, fieldName));
        return $containers;
    }

    function decorateMessageContainer($container, fieldName) {
        var locators = kendo.ui.validator.messageLocators;
        $container
            .addClass(INVALIDMSG)
            .attr(kendo.attr("for"), fieldName || "");
        for (var name in locators)
            if (locators.hasOwnProperty(name)) {
                locators[name].decorate($container, fieldName);
                $container.attr("role", "alert");
            }
    }

    function initConditionalRequired() {
        var $inputs = $(CONDITIONAL_REQUIRED_SELECTOR),
            $input;
        for (var i = 0, length = $inputs.length; i < length; i++) {
            $input = $inputs.eq(i);
            $input.closest(CONTROL_WRAPPER).find("label").toggleClass(REQUIRED_LABEL_CLASS, shouldValidate($input, extractParams($input, "required"), this, "mvcrequired"));
            // not calling this.updateConditionalRequired($inputs.eq(i), false) because at init time, we must not revalidate the input as it might hide the server error messages
        }
    }

    function updateConditionalRequired(input, revalidateIfRequired) {
        var self = this,
            $input = $(input),
            required = shouldValidate($input, extractParams($input, "required"), self, "mvcrequired");
        if (typeof revalidateIfRequired == "undefined") {
            revalidateIfRequired = true;
        }
        $input.closest(CONTROL_WRAPPER).find("label").toggleClass(REQUIRED_LABEL_CLASS, required);
        // if not required, we always need to revalidate the input to hide the "must not be empty" error if it is displayed
        // if required, revalidation is optional, with default being true
        if (!required || revalidateIfRequired) {
            self.validateInput($input);
        }
    }

    function errors() {
        var results = [],
            errs = this._errors;
        for (var error in errs)
            if (errs.hasOwnProperty(error))
                results.push(errs[error]);
        return results;
    }

    /**
     * Reset handler for cleaning up the form validator state.
     * Called on startup and on bound form reset.
     */
    function reset(startup) {
        var self = this;
        // reset optional errors list
        self._errors = {};
        // indicates that at least one control validation was already called
        self._isValidated = false;
        // indicates that all controls validation was called via validate()
        self._allValidated = false;
        // last remote call ID to be able to skip evaluating when
        // subsequent changes were made by user on same field or so
        self._lastRemoteCallId = 0;
        // number of pending requests
        self._pendingCount = 0;
        // unhighlight optional errors
        if (!startup) self.hideMessages();
    }

    var Validator = Widget.extend({

        // "constructor"
        init: function (element, options) {
            var self = this,
                resolved = resolveRules(element),
                validateAttributeSelector = "[" + kendo.attr("validate") + "!=false]";
            options = options || {};
            // update with ori custom rules and messages
            options.rules = $.extend(
                {}, kendo.ui.validator.rules, overrideRules(), resolved.rules, options.rules
            );
            options.messages = $.extend(
                {}, kendo.ui.validator.messages, overrideMessages(), resolved.messages, options.messages
            );
            Widget.fn.init.call(self, element, options);
            if (self.element.is(FORM)) {
                self.element.attr(ATTR_NOVALIDATE, ATTR_NOVALIDATE);
            }
            self._inputSelector = ENABLED_INPUT_SELECTOR + validateAttributeSelector + "," +
                ADDITIONAL_COMPONENTS_SELECTOR.split(",").join(validateAttributeSelector + ",") +
                validateAttributeSelector;
            self._checkboxSelector = ENABLED_CHECKBOX_SELECTOR + validateAttributeSelector;
            self.reset(true);
            self._attachEvents();
            // remove valid UI spans in grid edit modes generated on server
            self._cleanupGridValidationMarkup();
            // update invalid fields UI generated on server
            self._replaceServerGeneratedClasses();
            self._createErrorMessages();
            self._initConditionalRequired();
            // scroll to first invalid input validated on server
            if (self.options.focusFirstInvalidInput) {
                focusFirstInvalidInput.call(self);
            }
            self.info("initialized validator for %s", self.describeElement(self.element));
        },

        options: $.extend(true, {}, kendo.ui.defaultValidatorHighlighterOptions, {
            name: "Validator",
            // when true, validation message is created near widget's input
            showFieldErrorsInWidgets: true,
            // default validation UI type; used when this kind of data
            // is not present in widget instance itself or in its markup
            validationUi: VAL_UI_ICON,
            // when true, validation message is created in validation summary when found 
            showFieldErrorsInSummary: false,
            // set this to true in init if you want to apply success
            // classes on widget & icon after valid
            applySuccessClasses: false,
            // Sets whether to block submitting in pending mode or not.
            blockSubmitInPendingMode: false,
            // by default focuses first invalid input on submit attempt
            focusFirstInvalidInput: true,
            // tries to do the focusing with scroll animation
            // valid only when focusing first invalid input is enabled
            scrollToFirstInvalidInput: true,
            // default scroll animation duration
            scrollDuration: DEFAULT_SCROLL_DURATION,
            // default scrollig element selector used to scroll to first invalid input
            scroller: DEFAULT_SCROLLER,
            // scroll indent - amount of pixels to add to final element position
            // from the viewport border
            scrollDeltaLeft: 20,
            scrollDeltaTop: 80,
            // by default validation is done on blur and form submit
            validateOnBlur: true
        }),

        events: [
            EVENT_VALIDATE,
            EVENT_VALIDATE_RELATED,
            EVENT_CHANGE,
            EVENT_INPUT_VALIDATE,
            EVENT_INPUT_REMOTE_VALIDATE,
            EVENT_INVALID_INPUT_FOCUS
        ],

        // other methods
        _replaceServerGeneratedClasses: replaceServerGeneratedClasses,
        _createErrorMessages: createErrorMessages,
        _createErrorMessage: createErrorMessage,
        _initConditionalRequired: initConditionalRequired,
        prepareErrorMessageText: prepareErrorMessageText,
        errorMessage: kendo.ui.errorMessage,
        hideErrorMessage: kendo.ui.hideErrorMessage,
        toggleLoadingIcon: toggleLoadingIcon,
        summaryMessage: kendo.ui.summaryMessage,
        hideSummaryMessage: kendo.ui.hideSummaryMessage,
        hideElement: hideElement,
        validate: validate,
        validateInput: validateInput,
        validateRelatedInputs: validateRelatedInputs,
        updateConditionalRequired: updateConditionalRequired,
        _checkValidity: checkValidity,
        _extractMessage: extractMessage,
        isPendingMode: isPendingMode,
        _submit: submit,
        _attachEvents: attachEvents,
        destroy: destroy,
        value: value,
        _checkElement: checkElement,
        hideMessages: hideMessages,
        _findMessageContainer: findMessageContainer,
        _decorateMessageContainer: decorateMessageContainer,
        errors: errors,
        reset: reset,
        _cleanupGridValidationMarkup: cleanupGridValidationMarkup,
        displayValidationResult: displayValidationResult,
        _updateDisplayedInputErrors: updateDisplayedInputErrors,
        getSummary: getSummary,
        getSummaryErrorsSection: getSummaryErrorsSection,
        getSummarySuccessSection: getSummarySuccessSection

    });

    kendo.ui.plugin(Validator);

    kendo.ui.Validator.updated = true;

})(window.kendo.jQuery);
